import { useEffect, useMemo, useState } from 'react';
import FileList from './FileList';
import SendButton from './SendButton';
import SelectDir from './SelectDir';
import CountdownTimer from './CountdownTimer';
import Result from './Result';
import './Main.css';

type MainProps = {
  handleTimedOut: () => void,
  signedUrl: string,
  companySalt: string,
};

type FileCommandMessage = {
  type: 'files',
  value: File[]
};
type SendCommandMessage = {
  type: 'send',
  value: null
};
type FileObjectsResponseMessage = {
  type: 'fileObjects',
  value: FileObject[]
};

function Main(props: MainProps) {
  const [fileSent, setFileSent] = useState(false);
  const [files, setFiles] = useState<FileObject[]>([]);
  const sendable = () => {
    return files.length > 0 && files.length === files.filter(f => f.status === 'done').length;
  }
  const [fileSending, setFileSending] = useState(false);
  const [sendFailed, setSendFailed] = useState(false);
  const worker = useMemo(() => new Worker(new URL('./lib/worker.ts', import.meta.url)), []);
  useEffect(() => {
    worker.postMessage({type: 'signedUrl', value: props.signedUrl});
    worker.postMessage({type: 'companySalt', value: props.companySalt});
  }, [props.signedUrl]);
  worker.onmessage = (e) => {
    switch (e.data.type) {
      case 'fileObjects': {
        const fileObjects = e.data.value;
        setFiles(fileObjects);
        break;
      }
      case 'sendSucceeded': {
        setFileSent(true);
        break;
      }
      case 'sendFailed': {
        setFileSending(false);
        setSendFailed(true);
        break;
      }
      default: {
        console.log(`Sorry, we are out of ${e.data.type}.`);
      }
    }
  }
  const handleSelectDir = async (files: File[]) => {
    worker.postMessage({type: 'files', value: files});
  }
  const handleFileSending = () => {
    worker.postMessage({type: 'send'});
    setFileSending(true);
    setSendFailed(false);
  };
  if (fileSent) {
    return <Result files={files}/>
  }
  return (
    <>
      <CountdownTimer handleTimedOut={props.handleTimedOut}/>
      <div className='Main'>
        <SelectDir handleSelectDir={handleSelectDir} />
        {sendable() && <SendButton fileSending={fileSending} handleFileSending={handleFileSending} />}
        <div className='Clear'></div>
        {sendFailed && <p>送信に失敗しました。</p>}
        <FileList files={files} />
      </div>
    </>)
}

export default Main
